import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, ObservableInput, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  private readonly prefix = environment.apiBase;

  constructor(private httpClient: HttpClient) { }

  lookup(id: string, pin: string) {
    const endpoint = `${this.prefix}/cards/${id}/lookup?pin=${pin}`;
    const headers = new HttpHeaders().set('Accept-Language', 'it');
    const options = { headers: headers };
    const result = this.httpClient.get(endpoint, options).pipe(
      catchError(this.handleError)
    );
    return result;
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => new Error(error.error.message))
  }

}
 